<template>
    <div class="mapper-view" v-if="status">
        <IndependentAcceleratorsView />
        <ReportTemplate v-if="isGridVisible" :table-props="mappingColumns" :project-param-id="projectParamId"
            :mapper-param-id="mapperParamId" @toggleTabs="toggleTabs" />
        <div class="tabs-container" v-if="showTabs">
            <TabContentView @tab-selected="handleTabSelection" />
            <component :is="currentTabComponent" v-if="currentTabComponent" :projectParamId="projectParamId"
                :mapperParamId="mapperParamId" />
        </div>
    </div>
</template>

<script>
import ReportTemplate from "@/components/ReportTemplate.vue";
import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import IndependentAcceleratorsView from "./IndependentAcceleratorsView.vue";
import TabContentView from "./TabContentView.vue";
import UsageView from "./UsageView.vue";
import TransitionView from "./TransitionView.vue";
import ActivityTypesView from "./ActivityTypesView.vue";
import FieldMappingView from "./FieldMappingView.vue";
import ComponentView from "./ComponentView.vue";
import ActivitiesView from "./ActivitiesView.vue";
import ProcessDetailsView from "./ProcessDetailsView.vue";
import MappingReferencesView from "./MappingReferencesView.vue";
import MappingJobsView from "./MappingJobsView.vue";
import ChildActivities from "./ChildActivities.vue";
import ViewChildPopup from "./ViewChildPopup.vue";

export default {
    name: pageViews.MAPPERVIEW,
    methods: {
        setValuesToStore(type) {
            Store.commit("setType", type);
        },
        toggleTabs() {
            this.showTabs = !this.showTabs;
            this.isGridVisible = !this.isGridVisible;
            if (this.showTabs) {
                this.isGridVisible = false;
                // this.handleTabSelection(pageViews.USAGEVIEW);
                this.handleTabSelection(pageViews.COMPONENTVIEW);
                // this.handleTabSelection(pageViews.ACTIVITIES_VIEW);
            }
        },
        handleTabSelection(view) {
            switch (view) {
                // case pageViews.USAGEVIEW:
                //     this.currentTabComponent = UsageView;
                //     break;
                case pageViews.COMPONENTVIEW:
                    this.currentTabComponent = ComponentView;
                    break;
                case pageViews.PROCESS_DETAILS_VIEW:
                    this.currentTabComponent = ProcessDetailsView;
                    break;
                case pageViews.ACTIVITIES_VIEW:
                    this.currentTabComponent = ActivitiesView;
                    break;
                case pageViews.TRANSITIONVIEW:
                    this.currentTabComponent = TransitionView;
                    break;
                case pageViews.ACTIVITYTYPESVIEW:
                    this.currentTabComponent = ActivityTypesView;
                    break;
                case pageViews.FIELDMAPPINGVIEW:
                    this.currentTabComponent = FieldMappingView;
                    break;
                case pageViews.MAPPING_REFERENCES_VIEW:
                    this.currentTabComponent = MappingReferencesView;
                    break; 
                case pageViews.MAPPING_JOBS_VIEW:
                    this.currentTabComponent = MappingJobsView;
                    break; 
                case pageViews.CHILD_ACTIVITIES_VIEW:
                    this.currentTabComponent =  ChildActivities;
                    break; 
                case pageViews.VIEW_CHILD_ACTIVITIES_POPUP:
                    this.currentTabComponent =  ViewChildPopup;
                    break;
                default:
                    this.currentTabComponent = null;
            }
        },
        toggleGridVisibility() {
            this.isGridVisible = !this.isGridVisible;
            if (this.isGridVisible) {
                this.showTabs = false;
                // this.handleTabSelection(pageViews.USAGEVIEW);
                this.handleTabSelection(pageViews.COMPONENTVIEW);
            }
        }
    },
    mounted() {
        this.setValuesToStore(type.MAPPER);
    },
    provide() {
        return {
            toggleMapperTabs: this.toggleTabs // Provide the function to descendants
        };
    },
    components: {
        ReportTemplate,
        IndependentAcceleratorsView,
        TabContentView,
        UsageView,
        TransitionView,
        ActivityTypesView,
        FieldMappingView,
        ComponentView,
        ActivitiesView,
        ProcessDetailsView,
        MappingReferencesView,
        MappingJobsView,
        ChildActivities
    },
    data() {
        return {
            status: true,
            showTabs: false,
            currentTabComponent: null,
            isGridVisible: true,
            uploadConfigs: {
                action: "generator",
                actionLabel: "Generator",
                title: "Mapper Config Generator",
                type: type.MAPPER,
                accept: ".zip",
            },
            mappingColumns: {
                type: type.MAPPER,
                isMultiSelectionAllowed: true,
                configs: [
                    {
                        name: "mapperId",
                        label: "Mapper ID",
                        order: 2,
                    },
                    {
                        name: "requestDate",
                        label: "Request Date",
                        order: 1,
                        type: "date",
                        search: false,
                        defaultSelected: true
                    },
                    {
                        name: "fileName",
                        label: "File Name",
                        order: 4,
                        checked: true,
                        defaultSelected: true,
                        textAlign: "left",
                    },
                    {
                        name: "status",
                        label: "Status",
                        order: 5,
                        isSortable: true,
                        defaultSelected: true,
                        search: false
                    },
                    {
                        name: "complexity",
                        label: "Complexity",
                        order: 6,
                        isSortable: true,
                        defaultSelected: true,
                        search: false
                    },
                    {
                        name: "lastModifiedDate",
                        label: "Last Modified Date",
                        order: 7,
                        type: "date",
                        search: false
                    },
                    {
                        name: "mappingCount",
                        label: "Mapping Count",
                        order: 8,
                        search: false,
                        defaultSelected: true
                    },
                    {
                        name: "transitionCount",
                        label: "Transition Count",
                        order: 9,
                        search: false,
                        defaultSelected: true
                    },
                    // {
                    //     name: "activeMappingCount",
                    //     label: "Active Mapping Count",
                    //     order: 10,
                    //     search: false,
                    //     defaultSelected: true
                    // },
                    // {
                    //     name: "activeTransitionCount",
                    //     label: "Active Transition Count",
                    //     order: 11,
                    //     search: false,
                    //     defaultSelected: true
                    // },
                    // {
                    //     name: "inactiveMappingCount",
                    //     label: "Inactive Mapping Count",
                    //     order: 12,
                    //     search: false,
                    //     defaultSelected: true
                    // },
                    // {
                    //     name: "inactiveTransitionCount",
                    //     label: "Inactive Transition Count",
                    //     order: 13,
                    //     search: false,
                    //     defaultSelected: true
                    // },
                    {
                        name: "remarks",
                        label: "Remarks",
                        order: 14,
                        search: false,
                        textAlign: "left",
                        textOverflowStyle: "ellipsis",
                    }
                ],
                actions: {
                    viewPopup: {
                        label: 'View Output'
                    },
                    download: {
                        label: 'Request Download'
                    },
                    calculate: {
                        label: 'Calculate Complexity'
                    },
                }
            }
        };
    },
    props: ["projectParamId", "mapperParamId"],
}

</script>
<style scoped>
.links-container {
    margin-top: 20px;
    /* Adjust this value as needed */
}

.links-container a {
    margin-right: 10px;
    /* Adjust this value as needed */
    cursor: pointer;
    text-decoration: underline;
    color: blue;
}
</style>
